import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1];
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';

  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20fashion%20collage%20with%20scattered%20sneakers%20caps%20sunglasses%20and%20clothing%20on%20a%20warm%20terracotta%20and%20cream%20abstract%20gradient%20background%20soft%20natural%20lighting%20modern%20minimal%20aesthetic%20high%20detail&width=1600&height=900&seq=hero-bg-v2&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet fashion products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/30 to-background-50/90" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-16">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase text-background-50 bg-primary-500/80 rounded-full mb-6">
            {t('hero.eyebrow')}
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-6">
            {t('hero.h1')}
          </h1>
          <p className="text-base md:text-lg text-background-100/90 leading-relaxed mb-4 max-w-2xl">
            {t('hero.description')}
          </p>
          <p className="text-sm md:text-base text-background-200/80 leading-relaxed mb-8 max-w-xl">
            {t('hero.secondary')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              {t('cta.explore')}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href={`/${currentLang}/articles/cssbuy-spreadsheet-guide`}
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 font-semibold text-sm rounded-lg border border-background-50/30 hover:bg-background-50/30 transition-all whitespace-nowrap"
            >
              {t('cta.startGuide')}
            </a>
          </div>

          <p className="mt-8 text-xs text-background-200/70 flex items-center gap-2">
            <i className="ri-shield-check-line" />
            {t('hero.trust')}
          </p>
        </div>
      </div>
    </section>
  );
}